import heic2any from 'heic2any'

export const heicUrlToObjectUrl = async (url, type = 'image/jpeg') => {
  const urlObj = new URL(url)
  const transformedPathname = urlObj.pathname.toLowerCase()
  if (transformedPathname.endsWith('.heic') || transformedPathname.endsWith('.heif')) {
    return fetch(url)
      .then((res) => res.blob())
      .then((blob) => heic2any({ blob, toType: type }))
      .then((blob) => {
        return URL.createObjectURL(blob)
      })
  }
  return url
}



// WEBPACK FOOTER //
// ./src/utils/image.js